import reducers from './reducers';

export { default as favoriteSelectors } from './selectors';
export { default as favoriteOperations } from './operations';
export { default as favoriteTypes } from './types';

export default reducers;
